import React from "react";
import DividerBlock from "../../../../divider-block";
import FieldBlock from '../../../../field-block';
import { DatePicker, TimePicker } from "antd";
import { Col, Row } from "antd";
import i18n from "../../../../../i18n";

const { RangePicker } = DatePicker;

export default function AuctionPrice({
  tenderTimeStart,
  tenderTimeEnd,
  setLoadStart,
  setLoadEnd,
  setTenderStart,
  setTenderEnd,
  setTenderTimeStart,
  setTenderTimeEnd,
  getFieldErrors,
  dividerStyle}
) {
    return (
      <>
      <span className="divider-label">{i18n.t('consignorPage.createDelivery.content.divider.auction')}</span>
      <DividerBlock style={dividerStyle} />
      <Row gutter={[16, 24]} >
        <Col lg={12} md={24} sm={24} sx={24}>
          <FieldBlock  name="tenderStart" title={i18n.t('consignorPage.createDelivery.content.auction.tenderStart')} getErrors={getFieldErrors}>
            <RangePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              onChange={(date) => {
                  setTenderStart(date[0]);
                  setTenderEnd(date[1]);
              }}
            />
            <TimePicker
              defaultValue={tenderTimeStart}
              placeholder={i18n.t('consignorPage.createDelivery.content.auction.tenderTimeStart')}
              format="HH:mm"
              onChange={(time, timeString) => {setTenderTimeStart(time)}}
              style={{ width: "50%" }}
            />
            <TimePicker
              placeholder={i18n.t('consignorPage.createDelivery.content.auction.tenderTimeEnd')}
              defaultValue={tenderTimeEnd}
              format="HH:mm"
              onChange={(time, timeString) => {setTenderTimeEnd(time)}}
              style={{ width: "50%" }}
            />
          </FieldBlock>
        </Col>
      </Row>
      <Row gutter={[16, 24]} >
      </Row>
      </>
    );
}
